export const tableHeaderRowClass = "border-b border-border-default bg-surface-raised text-content-secondary dark:border-border-default-dark dark:bg-surface-raised-dark dark:text-content-secondary-dark";
export const tableHeaderCellClass = "px-4 py-3 text-xs font-semibold uppercase tracking-wide";
